import { videoConnectionDomain } from "../domains/index.ts";
import {
    VideoConnectionsStore,
    DeviceStatuses,
} from "../types";

export const $videoConnectionsStore = videoConnectionDomain.createStore<VideoConnectionsStore>({
    connections: {},
});

export const editCameraUrl = videoConnectionDomain.createEvent<{ cameraId: string }>()

export const $onlineCamerasUrls = videoConnectionDomain.createStore<string[]>([]);
export const  setCameraOnlineStatus = videoConnectionDomain.createEvent<{ url: string, status: DeviceStatuses }>();

